<script>
	import { mapMutations,mapState } from 'vuex';

	export default{
		data(){
			return {
				e : ''
			}
		},
		mounted(){
			this.e = this.tiendaSeleccionada;
		},
		computed:{
			...mapState(['login','tiendaSeleccionada'])
		},
		methods:{
			...mapMutations(['loginMutation','selectEjercicio']),
			start(tienda){
				this.loginMutation(true);
				this.selectEjercicio(tienda);
				this.$router.push({name: 'ams'});
			}
		}
	}
</script>
<template>
	<div class="bg-login">
		<img src="img/logoInicio.png" alt="">
		<h4>Emulador AMS</h4>
		<h3>Selecciona el negocio al que pertenezcas</h3>
		<!-- // <a @click="start()" class="btn-login">Iniciar</a> -->
		<img class="llega-donde-quieras" src="img/llega_a_donde_quieras.png" alt="">
		<div class="content-select-ejercicios">
			
			<div style="margin-top: 37px;">
				
				<div @click="start('autoservicio')" class="text-center">
					<label class="radio-inline">
						<img src="img/logoWalmart.png" alt="">
						<input type="radio" v-model="e" name="ejercicio" value="autoservicio">Autoservicio
					</label>
				</div>
			</div>
			
			<div style="margin-top: 37px;">
				<div @click="start('sams')" class="text-center">
					<label class="radio-inline">
						<img src="img/logoSams.png" alt="">
						<input type="radio" v-model="e" name="ejercicio" value="sams">Sam's Club
					</label>
				</div>
			</div>

		</div>
	</div>
</template>